import React from 'react'
import { ITotalPriceProps } from './total-price-props.interface'
import './total-price.scss'
import { useTranslation } from 'react-i18next'

const TotalPrice: React.FC<ITotalPriceProps> = ({ price }) => {
  const { t } = useTranslation()

  return (
    <div className="total-price-cnt">
      <span className="price-text">{t('total')}</span>
      <span className="total-price">{price} €</span>
    </div>
  )
}

export default TotalPrice
